import { Routes } from '@angular/router';

import { maintenanceGuard } from './core/guards/maintenance.guard';

export const appRoutes: Routes = [
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./feature/maintenance/maintenance.routes').then(
        (module) => module.MAINTENANCE_ROUTES,
      ),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./feature/onboarding/onboarding.module').then(
        (module) => module.OnboardingModule,
      ),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./feature/login/login.routes').then(
        (module) => module.LOGIN_ROUTES,
      ),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'trading',
    loadChildren: () =>
      import('./feature/trading/trading.module').then(
        (module) => module.TradingModule,
      ),
    canActivate: [maintenanceGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./feature/home/home.routes').then((module) => module.HOME_ROUTES),
    canActivate: [maintenanceGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./feature/onboarding-v2/onboarding-v2.routes').then(
        (module) => module.ONBOARDING_V2_ROUTES,
      ),
    canActivate: [maintenanceGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
